//病例管理
import { post, get, postExFile } from "@utils/httpUtil";

//第三方住友链接
export function getZhuYouUrlDetail(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return get(`/activity/medicalRecord/getZhuYouUrlDetail`, data, config);
}
//分页查询待审核病例
export function medicalRecordPageToAccept(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/content/medicalRecord/pageToAccept`, data, config);
}
//获取服务费
export function medicalRecordGetServiceFee(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/content/medicalRecord/getServiceFee`, data, config);
}

//分开模式关联case
export function getContentRelationByRecordId(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/content/medicalRecord/lhqw/getContentRelationByRecordId`, data, config);
}
//通过
export function medicalRecordAccept(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/content/medicalRecord/accept`, data, config || { ignoreError: true });
}

//拒绝
export function medicalRecordRefuse(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/content/medicalRecord/refuse`, data, config);
}

//导出待审核病例
export function medicalRecordExportToAccept(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`/content/medicalRecord/exportToAccept`, data, config);
}
//导出待审核病例
export function getMedicalRecordByMedicalRecordId(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/content/medicalRecord/lhqw/getMedicalRecordByMedicalRecordId`, data, config);
}

//------------------------------------------------------------------------------------------------------------------------------------------------------------------

//分页查询已审核病例
export function medicalRecordPageAccept(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/content/medicalRecord/pageAccept`, data, config);
}

//导出已审核病例列表
export function medicalRecordExportAccept(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`/content/medicalRecord/exportAccept`, data, config);
}

//撤回采纳
export function medicalRecordRevokeAccept(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/content/medicalRecord/revokeAccept`, data, config);
}

//设置为优质病例
export function medicalRecordSetHighQuality(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/content/medicalRecord/setHighQuality`, data, config || { ignoreError: true });
}

//撤回优质病例
export function medicalRecordCancelHighQuality(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/content/medicalRecord/cancelHighQuality`, data, config);
}

//奖励详情接口
export function medicalRecordHighQualityDetail(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/content/medicalRecord/highQualityDetail`, data, config);
}

//发放额外奖励
export function medicalRecordGiveExtraReward(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/content/medicalRecord/giveExtraReward`, data, config);
}

//取消额外奖励
export function medicalRecordCancelExtraReward(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/content/medicalRecord/cancelExtraReward`, data, config);
}

//上线
export function medicalRecordOnline(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/content/medicalRecord/online`, data, config);
}

//下线
export function medicalRecordOffline(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/content/medicalRecord/offline`, data, config);
}

//设置推荐

export function medicalRecordSetRecommend(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/content/medicalRecord/setRecommend`, data, config);
}

//取消设置推荐
export function medicalRecordCancelRecommend(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/content/medicalRecord/cancelRecommend`, data, config);
}

//------------------------------------------------------------------------------------------------------------------------------------------------------------------

//分页查询已拒绝病例
export function medicalRecordPageReject(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/content/medicalRecord/pageReject`, data, config);
}

//删除病例
export function medicalRecordDelete(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/content/medicalRecord/delete`, data, config);
}

//导出已拒绝病例列表
export function medicalRecordExportReject(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`/content/medicalRecord/exportReject`, data, config);
}

//分页查询病例投票详情
export function pageVoteRecordForMedical(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/vote/pageVoteRecordForMedical`, data, config);
}

export function listPvUvByCaseIds(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/content/medicalRecord/listPvUvByCaseIds`, data, config);
}
